import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ThemeProvider } from "@/theme/ThemeProvider";
import ThemeCustomizer from "@/components/theme/ThemeCustomizer";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";
import Login from "@/pages/Login";
import AppLayout from "@/components/AppLayout";
import POS from "@/pages/POS";
import Dashboard from "@/pages/Dashboard";
import Products from "@/pages/Products";
import Categories from "@/pages/Categories";
import Users from "@/pages/Users";
import Transactions from "@/pages/Transactions";
import Purchases from "@/pages/Purchases";
import PrinterSettings from "@/pages/PrinterSettings";
import Stores from "@/pages/Stores";
import Reports from "@/pages/Reports";
import Piutang from "@/pages/Piutang";
import Stok from "@/pages/Stok";
import Shifts from "@/pages/Shifts";
import Backup from "@/pages/Backup";
import PaymentMethods from "@/pages/PaymentMethods";
import Tenants from "@/pages/Tenants";
import SystemStatus from "@/pages/SystemStatus";
import BackupSettings from "@/pages/BackupSettings";
import Platform from '@/pages/Platform';
import PublicStore from '@/pages/PublicStore';
import AuditLogs from "@/pages/AuditLogs";
import Warehouse from '@/pages/Warehouse';
import WhatsApp from '@/pages/WhatsApp';
function Splash() {
  return (
    <div className="h-screen w-screen flex items-center justify-center bg-background">
      <Loader2 className="h-10 w-10 animate-spin text-primary" />
    </div>
  );
}

function Protected({ children, adminOnly, masterOnly, warehouseOnly }) {
  const { user, loading, tenant } = useAuth();
  if (loading || user === null) return <Splash />;
  if (!user) return <Navigate to="/login" replace />;
  if (user.role === "warehouse" && !["/warehouse", "/products", "/login"].includes(window.location.pathname)) return <Navigate to="/warehouse" replace />;
  if (warehouseOnly && !["admin", "warehouse"].includes(user.role)) return <Navigate to="/pos" replace />;
  if (adminOnly && user.role !== "admin") return <Navigate to="/pos" replace />;
  if (masterOnly && (tenant?.kind !== "master" || user.role !== "admin")) return <Navigate to="/pos" replace />;
  return children;
}

function AppRoutes() {
  const { user, loading, tenant, tenantError } = useAuth();
  if (tenantError) return <main className="p-8" role="alert">{tenantError}</main>;
  if (!tenant) return <Splash />;
  return (<Routes>
    <Route path="/login" element={loading ? <Splash /> : user ? <Navigate to="/" replace /> : <Login />} />
    <Route element={<Protected><AppLayout /></Protected>}>
      <Route path="/audit-logs" element={<Protected adminOnly><AuditLogs /></Protected>} />
      <Route path="/appearance" element={<Protected adminOnly><ThemeCustomizer /></Protected>} />
      <Route path="/master/platform" element={<Protected masterOnly><Platform /></Protected>} />
      <Route path="/warehouse" element={<Protected warehouseOnly><Warehouse /></Protected>} />
      <Route path="/whatsapp" element={<Protected adminOnly><WhatsApp /></Protected>} />
      <Route path="/master/tenants" element={<Protected masterOnly><Tenants /></Protected>} />
      <Route path="/master/system" element={<Protected masterOnly><SystemStatus /></Protected>} />
      <Route path="/master/backup" element={<Protected masterOnly><BackupSettings /></Protected>} />
      <Route path="/" element={<Navigate to="/pos" replace />} /><Route path="/pos" element={<POS />} />
      <Route path="/dashboard" element={<Protected adminOnly><Dashboard /></Protected>} /><Route path="/reports" element={<Protected adminOnly><Reports /></Protected>} /><Route path="/shifts" element={<Protected adminOnly><Shifts /></Protected>} /><Route path="/purchases" element={<Protected adminOnly><Purchases /></Protected>} /><Route path="/suppliers" element={<Protected adminOnly><Navigate to="/users?tab=suppliers" replace /></Protected>} /><Route path="/products" element={<Protected warehouseOnly><Products /></Protected>} /><Route path="/stok" element={<Protected adminOnly><Stok /></Protected>} /><Route path="/categories" element={<Protected adminOnly><Categories /></Protected>} /><Route path="/users" element={<Protected adminOnly><Users /></Protected>} /><Route path="/settings" element={<Protected adminOnly><PrinterSettings /></Protected>} /><Route path="/payment-methods" element={<Protected adminOnly><PaymentMethods /></Protected>} /><Route path="/stores" element={<Protected adminOnly><Stores /></Protected>} /><Route path="/backup" element={<Protected adminOnly><Backup /></Protected>} /><Route path="/transactions" element={<Transactions />} /><Route path="/piutang" element={<Piutang />} />
    </Route><Route path="*" element={<Navigate to="/" replace />} />
  </Routes>);
}
function App() {
  if (window.location.hostname === "store.masivi.id") return <PublicStore />;
  return (
    <div className="App min-h-screen">
      <ThemeProvider><AuthProvider>
        <BrowserRouter>
          <AppRoutes />
        </BrowserRouter>

      </AuthProvider></ThemeProvider>
    </div>
  );
}

export default App;
